/**
 * @desc 顶部导航组件
 * @time 2023-07-31 15:47:26
 * @user simxin
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { t } from '@src/utils/translate';
import { NavMenu, List } from '@tencent/tea-component';
import { Nav } from '@tencent/tpm-trtc-console';
import { clearCookie, getUin, setCookie } from '@src/utils/cookies';
import { usePortalStore } from '@src/store';
import { trtcCGIRequest } from '@src/utils/api/request';
import { isPreTest } from '@src/utils/tools';
import qs from 'qs';
import { getPrimaryConsole } from '@src/utils/tools/other-site-tools';
import { PreviewVersion } from './preview-version';
import { useDelayedRedirect } from '../link/hooks/useDelayedRedirect';
import RedirectModalWrapper from '../link/redirect-modal';
import { reportLoginProcess } from '@src/utils/report';
import { AppSelectPlanB } from './app-select-planb';
const langs = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: '简体中文',
    value: 'zh',
  },
  {
    label: '日本語',
    value: 'jp',
  },
  {
    label: '한국어',
    value: 'ko',
  },
];

export const LayoutNavPlanB = () => {
  const navigate = useNavigate();
  const {
    redirectModalVisible,
    closeRedirectModal,
    redirectWithModal,
    redirectModalProps,
  } = useDelayedRedirect();

  const nickname = usePortalStore(state => state.nickname) || '';

  const app = usePortalStore(state => state.app);
  const lang = window.VERSION || 'en';
  const langLabel = langs.find(item => item.value === lang)?.label;

  const logout = () => {
    reportLoginProcess('logoutByNavClick');
    trtcCGIRequest('common/logout', {}).then(() => {
      clearCookie();
      window.location.href = `//${window.AVPORTAL_HOST}/login`;
    });
  };

  const changeLanguage = (lang: string) => {
    setCookie('saas_intl', lang);
    setCookie('language', lang);
    var pathname = window.location.pathname;
    const search = window.location.search;
    var param: any = /\?/.test(search) ? qs.parse(search?.split('?')?.[1]) : {};
    param.language = lang;
    param.lang = lang;
    navigate(pathname + '?' + qs.stringify(param), {
      replace: true,
    });
    window.location.reload();
  };
  const showPreview = isPreTest();

  return (
    <NavMenu
      className="is-v2"
      left={
        <>
          <NavMenu.Item
            type="logo"
            onClick={() => {
              navigate('/');
            }}
          >
            <div className="nav-logo">
              <img
                src="/logo-new.svg"
                alt="logo"
                width="138px"
                height="28px"
                style={{ paddingLeft: '10px' }}
              />
              {app !== 'trtc' && (
                <img src="/home.svg" alt="logo" width="20px" height="20px" />
              )}
            </div>
          </NavMenu.Item>
          <>
            {' '}
            <div
              className="trtc-divider-vertical"
              style={{ marginLeft: '-6px', marginRight: '20px' }}
            />
            <NavMenu.Item style={{marginRight: 10, fontSize: 14}}>
              <span>Deskbuddy</span>
            </NavMenu.Item>
          </>
          <AppSelectPlanB />
          {showPreview && <PreviewVersion />}
        </>
      }
      right={
        <>
          {/* <NavMenu.Item
            onClick={() => {
              reportMenuClick('ConsoleMenuType', 'Demo');
              window.open(`//${window.AVPORTAL_HOST}/demo`, '_blank');
            }}
          >
            {t('Demo')}
          </NavMenu.Item>
          <NavMenu.Item
            onClick={() => {
              reportMenuClick('ConsoleMenuType', 'Docs');
              window.open(`//${window.AVPORTAL_HOST}/document`, '_blank');
            }}
          >
            {t('Docs')}
          </NavMenu.Item>
          <NavMenu.Item
            type="dropdown"
            overlay={() => (
              <List type="option" style={{ width: 160 }}>
                <List.SubMenu label={t('Technical Support')}>
                  <List type="option">
                    <List.Item
                      onClick={() => {
                        reportMenuClick('ConsoleMenuItem', 'WhatsApp');
                        window.open(
                          'https://chat.whatsapp.com/Gfbxk7rQBqc8Rz4pzzP27A',
                          '_blank',
                        );
                      }}
                    >
                      {t('WhatsApp Group')}
                    </List.Item>
                    <List.Item
                      onClick={() => {
                        reportMenuClick('ConsoleMenuItem', 'Telegram');
                        window.open('https://t.me/+EPk6TMZEZMM5OGY1', '_blank');
                      }}
                    >
                      {t('Telegram Group')}
                    </List.Item>
                  </List>
                </List.SubMenu>
                <List.Item
                  onClick={() => {
                    reportMenuClick('ConsoleMenuItem', 'FAQ');
                    window.open(
                      'https://stackoverflow.com/questions/tagged/trtc.io',
                      '_blank',
                    );
                  }}
                >
                  {t('FAQ Community')}
                </List.Item>
                <List.Item
                  onClick={() => {
                    reportMenuClick('ConsoleMenuItem', 'Ticket');
                    redirectWithModal(getPrimaryConsole('/workorder/category'));
                  }}
                >
                  {t('Ticket')}
                </List.Item>
                <List.Item
                  onClick={() => {
                    reportMenuClick('ConsoleMenuItem', 'Message');
                    redirectWithModal(getPrimaryConsole('/message'));
                  }}
                >
                  {t('Message Center')}
                </List.Item>
              </List>
            )}
          >
            {t('Help')}
          </NavMenu.Item>
          <NavMenu.Item
            type="dropdown"
            overlay={() => (
              <Nav.ListGroup>
                <List type="option">
                  {langs.map(lang => (
                    <List.Item
                      key={lang.value}
                      onClick={() => {
                        changeLanguage(lang.value);
                      }}
                    >
                      {lang.label}
                    </List.Item>
                  ))}
                </List>
              </Nav.ListGroup>
            )}
          >
            {langLabel}
          </NavMenu.Item>
          <div
            className="trtc-divider-vertical"
            style={{ marginLeft: '10px', marginRight: '10px' }}
          />
          <NavMenu.Item
            onClick={() => {
              redirectWithModal(getPrimaryConsole('/expense'));
            }}
          >
            <a>
              <BillsIcon size={16} color="#22262E" />
              <Trans>Bills</Trans>
            </a>
          </NavMenu.Item> */}
          <NavMenu.Item
            type="dropdown"
            overlay={() => (
              <Nav.ListGroup>
                <List type="option">
                  {langs.map(lang => (
                    <List.Item
                      key={lang.value}
                      onClick={() => {
                        changeLanguage(lang.value);
                      }}
                    >
                      {lang.label}
                    </List.Item>
                  ))}
                </List>
              </Nav.ListGroup>
            )}
          >
            {langLabel}
          </NavMenu.Item>
          <NavMenu.Item
            type="dropdown"
            overlay={() => (
              <Nav.ListGroup>
                <List>
                  <List.Item>
                    <Nav.ListOption
                      title={nickname}
                      description={`Account ID ：${getUin()}`}
                    />
                  </List.Item>
                </List>
                <List type="option">
                  <List.Item onClick={logout}>{t('Log out')}</List.Item>
                </List>
              </Nav.ListGroup>
            )}
          >
            <Nav.User version="v2">{nickname || '-'}</Nav.User>
          </NavMenu.Item>
          <RedirectModalWrapper
            {...redirectModalProps}
            visible={redirectModalVisible}
            close={closeRedirectModal}
          />
        </>
      }
    />
  );
};
